import { Component, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { Subscription } from 'rxjs';
import { LoadingService } from '../../../services/loading.service';
import { AuthService } from '../../../services/auth.service';
import { ChatService } from '../../../services/chat.service';
import { AgencySidebarComponent } from '../sidebar/agency-sidebar.component';
import { AgencyHeaderComponent } from '../agency-header/agency-header.component';
import { FooterComponent } from '../components/footer/footer.component';
import { PrivacyBannerComponent } from '../components/privacy-banner/privacy-banner.component';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { ChatPopupComponent } from './components/chat-popup/chat-popup.component';

@Component({
  selector: 'app-agency-layout-xontainer',
  templateUrl: './agency-layout-xontainer.component.html',
  styleUrls: ['./agency-layout-xontainer.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    RouterOutlet,
    AgencySidebarComponent,
    AgencyHeaderComponent,
    FooterComponent,
    PrivacyBannerComponent,
    AngularSvgIconModule,
    ChatPopupComponent
  ],
})
export class AgencyLayoutXontainerComponent implements OnInit, OnDestroy {
  menuItems:any = [
    {
      desc: 'Gestion des établissements',
      path: '',
      btnText: 'ACCÉDER AUX ÉTABLISSEMENTS'
    },
    {
      desc: 'Gestion des professionnels de santé',
      path: '',
      btnText: 'ACCÉDER AUX PROFESSIONNELS'
    },
    {
      desc: 'Gestion de vos agences',
      path: 'agency/agencies',
      btnText: 'ACCÉDER AUX AGENCES'
    },
    {
      desc: 'Gestions de vos accès',
      path: 'agency/users',
      btnText: 'ACCÉDER AUX UTILISATEURS'
    },
    {
      desc: 'Gestions des missions',
      path: 'agency/missions',
      btnText: 'ACCÉDER AUX MISSIONS'
    },
  ]

  title = 'collary-front';
  loading = false;
  subscription: Subscription;
  isAuthenticated = false;
  isChatOpen = false;
  isChatActive = true; // Control whether chat feature is visible
  totalUnreadCount = 0;
  private unreadCountSubscription: Subscription | null = null;
  private unreadRefreshInterval: any;
  private chatOpenSubscription: Subscription | null = null;
  private chatActiveSubscription: Subscription | null = null;

  constructor(
    public loadingService: LoadingService,
    private authService: AuthService,
    private chatService: ChatService
  ) {}

  ngOnInit() {
    this.subscription = this.loadingService.getLoading().subscribe((value) => {
      this.loading = value;
    });

    // Subscribe to chat active status changes
    this.chatActiveSubscription = this.chatService.chatActive$.subscribe((isActive: boolean) => {
      this.isChatActive = isActive;
    });

    // Load initial chat active status
    this.isChatActive = this.chatService.isChatActive;

    // Subscribe to user authentication state
    this.authService.getUser().subscribe(user => {
      this.isAuthenticated = !!user;
      if (user && user.id) {
        // Load initial unread count
        this.loadTotalUnreadCount(user.id);

        // Subscribe to unread count updates from WebSocket
        //this.unreadCountSubscription = this.chatService.unreadCount$.subscribe(() => {
          // Only reload if chat is NOT open
          //if (!this.isChatOpen) {
            //this.loadTotalUnreadCount(user.id);
          //}
       // });

        // Subscribe to chat open/close events
        this.chatOpenSubscription = this.chatService.chatOpen$.subscribe((count: number) => {
          this.isChatOpen = count > 0;
          if (this.isChatOpen) {
            // When chat opens, immediately reset counter to 0
            this.totalUnreadCount -= count;
          } 
          //else {
            // When chat closes, reload the count
            // this.loadTotalUnreadCount(user.id);
          //}
        });

        // Refresh unread count every 10 seconds
        this.unreadRefreshInterval = setInterval(() => {
          //if (!this.isChatOpen) {
            this.loadTotalUnreadCount(user.id);
          // }
        }, 5000);
      }
    });
  }

  loadTotalUnreadCount(userId: number): void {  
    if (this.isChatActive) { 
      this.chatService.getTotalUnreadCount(userId, 'AGENCY').subscribe({
        next: (count) => {
          this.totalUnreadCount = count;
        },
        error: (error) => {
          console.error('Error loading unread count:', error);
        }
      });
    }  
  }

  toggleChat() {
    this.isChatOpen = !this.isChatOpen;
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
    if (this.unreadCountSubscription) {
      this.unreadCountSubscription.unsubscribe();
    }
    if (this.chatOpenSubscription) {
      this.chatOpenSubscription.unsubscribe();
    }
    if (this.chatActiveSubscription) {
      this.chatActiveSubscription.unsubscribe();
    }
    if (this.unreadRefreshInterval) {
      clearInterval(this.unreadRefreshInterval);
    }
  }

}
